<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      common_info: {
        store: {},
      },
      isRouterAlive: true,
    };
  },
  created() {
    let that = this;
    this.common.getCommonInfo(this, function () {
      that.ttshop_name = that.common_info.store.name;
      const username = window.localStorage.getItem('qycgTitle');
      console.log(username.length)
      if (username.length > 2) {
        console.log(1)
        document.title = username;
      } else {
        // document.title = that.$store.state.qycg_title;
        document.title = that.common_info.store.name;
        console.log(that.common_info.store.name,"1")
      }
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = that.common_info.store.icon;
      document.getElementsByTagName("head")[0].appendChild(link);
      let head = document.getElementsByTagName("head");
      let meta = document.createElement("meta");
      document
        .querySelector('meta[name="keywords"]')
        .setAttribute("content", that.common_info.store.seo_key);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", that.common_info.store.seo_desc);
    });
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">

.over_two{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.over_one{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
